// MOBIL MENÜ (lap-alsó sheet) — amit az alsó nav nem visz: fiók-váltó és nyelv.
//
// JOGI LAPOK ITT NINCSENEK (user-döntés): a Profil lap „Jogi tudnivalók" szekciója viszi őket, és
// az alsó navban a Profil egy koppintásra van — a menüben duplikálva csak zaj lenne.
//
// A tartalom NEM másolat: a fiók-listát a sidebarral KÖZÖS `PortalAccountList` adja, a nyelv-váltó ugyanaz a
// két gomb, mint a topbarban (ott `sm`-től látszik, itt telefonon).
import type { PortalMeResponse } from '@atlas/contracts';
import { useTranslation } from 'react-i18next';

import { PortalAccountList } from '@/components/portal/portal-sidebar';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';

export interface PortalMobileMenuProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  me: PortalMeResponse | undefined;
  accountId: string | null;
  onAccountChange: (id: string | null) => void;
}

export function PortalMobileMenu({
  open,
  onOpenChange,
  me,
  accountId,
  onAccountChange,
}: PortalMobileMenuProps): JSX.Element {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'hu';

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[300px] max-w-[88vw] p-4">
        <SheetTitle>{t('portal.shell.menu')}</SheetTitle>
        <div className="mt-4 space-y-5">
          <PortalAccountList
            me={me}
            accountId={accountId}
            onAccountChange={(id) => {
              onAccountChange(id);
              onOpenChange(false);
            }}
          />

          <div>
            <Text variant="overline" as="div" className="mb-2">
              {t('portal.shell.language')}
            </Text>
            <div
              role="group"
              aria-label={t('portal.shell.language')}
              className="border-border bg-muted/40 flex gap-0.5 rounded-[9px] border p-0.5"
            >
              {(
                [
                  ['hu', 'Magyar'],
                  ['en', 'English'],
                ] as const
              ).map(([code, label]) => (
                <button
                  key={code}
                  type="button"
                  aria-pressed={lang === code}
                  onClick={() => void i18n.changeLanguage(code)}
                  className={cn(
                    'ease-atlas flex-1 rounded-[7px] px-2 py-1.5 text-[12.5px] font-medium transition-colors duration-150',
                    lang === code
                      ? 'bg-card text-foreground shadow-sm'
                      : 'text-muted-foreground hover:text-foreground',
                  )}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
